import { Country, ErrorCode } from '@afterpaytouch/portal-api/types'
import { CheckoutError, InitialData, TerminalErrorCode } from '../../model'
import { isValidEmail } from '../validation'

export interface CheckoutValidation {
  statusCode?: number
  merchant: {
    supportedCountries: Country[]
  }
  crossRegionUserSignIn?: unknown
}

interface CheckoutValidatedInitialDataSuccess {
  error: null
  initialData: InitialData
}

interface CheckoutValidatedInitialDataError {
  error: CheckoutError
}

type CheckoutValidatedInitialData = CheckoutValidatedInitialDataSuccess | CheckoutValidatedInitialDataError

export const validateInitialData = (initialData: InitialData | null): CheckoutValidatedInitialData => {
  if (initialData === null) {
    return {
      error: {
        error: TerminalErrorCode.Default,
        errorCode: ErrorCode.InvalidToken,
      },
    }
  }
  return {
    error: null,
    initialData,
  }
}

export const validateCheckoutStatus = (checkout: CheckoutValidation): boolean => {
  return checkout.statusCode === 402
}

export const validateMerchantCountry = (checkout: CheckoutValidation, country: Country): boolean => {
  return !checkout.merchant.supportedCountries.includes(country) && typeof checkout.crossRegionUserSignIn === 'undefined'
}

export const validateEmailFormat = (email: string): boolean => {
  return isValidEmail(email)
}
